import { FeatureFlagList, FeatureFlagsService } from './../../core/settings/feature-flags.service';
import { Directive, OnInit, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[featureFlag]',
})
export class FeatureFlagDirective implements OnInit {
  private _requiredFlag: FeatureFlagList | string = '';
  private _isHidden = true;

  private _flagChanged: Subscription;

  @Input() set featureFlag(val) {
    if (val) {
      this._requiredFlag = val;
      this.updateView();
    }
  }
  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private _featureFlags: FeatureFlagsService,
  ) {
    this._flagChanged = this._featureFlags.featureFlagChanged.subscribe(({ flag, value }) => {
      if (flag === this._requiredFlag) {
        this.updateView();
      }
    });
  }

  ngOnInit() {
    this.updateView();
  }

  // Update the view based on availability of Feature flag
  private updateView() {
    if (this.checkValidity()) {
      if (this._isHidden) {
        this._viewContainer.createEmbeddedView(this._templateRef);
        this._isHidden = false;
      }
    } else {
      this._viewContainer.clear();
      this._isHidden = true;
    }
  }

  /**
   * Checks the FeatureFlagsService to see if the flag is enabled
   * @returns boolean
   */
  private checkValidity(): boolean {
    return this._requiredFlag && this._featureFlags.isFeatureFlagEnabled(this._requiredFlag);
  }

  ngOnDestroy() {
    this._flagChanged && this._flagChanged.unsubscribe();
  }
}
